import { Cliente } from '../../pessoa/cliente/cliente';
import { Representante } from '../../pessoa/representante/representante';
import { ClienteAnaliseMercadoClassificacaoSearchLancamento } from './lancamento';
import { TablePercProgressComponent } from '../../../shared';

export class ClienteAnaliseMercadoClassificacaoSearch {
    id: number;
    ano: number;
    idClassificacaoFaturamentoPretendida: number;
    codigoClassificacaoFaturamentoPretendida: string;
    nomeClassificacaoFaturamentoPretendida: string;
    idAnaliseMes: number;
    mes: number;

    // Classificação
    idAnaliseClassificacao: number;
    lancamentoAnaliseClassificacao: number;
    solicitarPrecoMedioAnaliseClassificacao: boolean;
    idGrupoClassificacao: number;
    classificacoesSlug: number[];
    classificacoesNome: string;
    classificacoes: ClienteAnaliseMercadoClassificacaoSearchLancamento[];

    // Cliente
    idCliente: number;
    idPessoa: number;
    tipoPessoa: number;
    cliente: Cliente;
    cnpjCpfCliente: string;
    codigoIntegracaoErpCliente: string;
    nomeCliente: string;
    nomeFantasiaCliente: string;
    cadastro: number;
    situacao: number;
    nomeCidadeCliente: string;
    ufCliente: string;
    motivoBaixaCliente: string;
    idRepresentante: number;
    representante: Representante;
    codigoIntegracaoErpRepresentante: string;
    cnpjCpfRepresentante: string;
    nomeRepresentante: string;
    nomeFantasiaRepresentante: string;
    idClienteTipo: number;
    nomeClienteTipo: string;
    idItemTipo: number;
    nomeItemTipo: string;

    // Central de compras
    idClienteCentralCompra: number;
    codigoIntegracaoErpClienteCentralCompra: string;
    nomeClienteCentralCompra: string;
    nomeFantasiaClienteCentralCompra: string;
    percParticipacaoCentralCompra: number;

    // Quantidade Potencial
    quantidadePotencial: number;
    // Peso Potencial
    pesoPotencial: number;
    // Valor Potencial
    valorPotencial: number;

    // Status Pretendido
    statusPretendido: number;
    // Quantidade Pretendida
    quantidadePretendida: number;
    quantidadePretendidaPerc: number;
    quantidadePretendidaValorUnitario: number;
    // Peso Pretendido
    pesoPretendido: number;
    pesoPretendidoPerc: number;
    pesoPretendidoValorUnitario: number;
    // Valor Pretendido
    valorPretendido: number;
    valorPretendidoPerc: number;

    // Status Projetado
    statusProjetado: number;
    idEtapaNegociacaoProjecao: number;
    nomeEtapaNegociacaoProjecao: string;
    corEtapaNegociacaoProjecao: string;
    // Quantidade Projetada
    quantidadeProjetada: number;
    quantidadeProjetadaPerc: number;
    quantidadeProjetadaPercProgress: TablePercProgressComponent;
    quantidadeProjetadaValorUnitario: number;
    // Peso Projetado
    pesoProjetado: number;
    pesoProjetadoPerc: number;
    pesoProjetadoPercProgress: TablePercProgressComponent;
    pesoProjetadoValorUnitario: number;
    // Valor Projetado
    valorProjetado: number;
    valorProjetadoPerc: number;
    valorProjetadoPercProgress: TablePercProgressComponent;

    // Quantidade Realizada
    quantidadeRealizada: number;
    quantidadeRealizadaPercPretendida: number;
    quantidadeRealizadaPercProjetada: number;
    quantidadeRealizadaPercProjetadaProgress: TablePercProgressComponent;
    // Peso Realizado
    pesoRealizado: number;
    pesoRealizadoPercPretendido: number;
    pesoRealizadoPercProjetado: number;
    pesoRealizadoPercProjetadoProgress: TablePercProgressComponent;
    // Valor Realizado
    valorRealizado: number;
    valorRealizadoPercPretendido: number;
    valorRealizadoPercProjetado: number;
    valorRealizadoPercProjetadoProgress: TablePercProgressComponent;
}
